export default __webpack_public_path__ + "static/media/usdc.57877cf1.svg";